import { httpClient } from "./BaseApi";

const PROCEDURE_SPECIALITY_CHOOSE_URL = "api/treatment/procedure/speciality/choose.json";

const SpecialityApi = {
  getAll: (params) => httpClient.get(PROCEDURE_SPECIALITY_CHOOSE_URL, { params }),
};

export default SpecialityApi;
